import type { ShoppingList } from '../domain/shopping-list.model'
import type { ShoppingListRepository } from '../infra/shopping-list.repository'

import type {
  CartDiscountNotAppliedError,
  CartDiscountNotFoundError,
  ShoppingListNotFoundError,
  UserNotAuthorizedError,
} from '@invivodf/module-shopping-list-b2ag-interfaces'

interface Dependencies {
  shoppingListRepository: ShoppingListRepository
}

interface AddPromoCodeToShoppingListUseCase {
  (
    shoppingListId: string,
    promoCode: string,
  ): Promise<
    | ShoppingList
    | CartDiscountNotAppliedError
    | CartDiscountNotFoundError
    | ShoppingListNotFoundError
    | UserNotAuthorizedError
  >
}

export function createAddPromoCodeToShoppingListUseCase({
  shoppingListRepository,
}: Dependencies): AddPromoCodeToShoppingListUseCase {
  return async (
    shoppingListId: string,
    promoCode: string,
  ): Promise<
    | ShoppingList
    | CartDiscountNotAppliedError
    | CartDiscountNotFoundError
    | ShoppingListNotFoundError
    | UserNotAuthorizedError
  > => {
    return await shoppingListRepository.addPromoCodeToShoppingList(shoppingListId, promoCode)
  }
}
